import * as React from 'react';
// TODO: change move these styles once it all works
import * as styles from '../../layout/layout.scss';
import InputWithLabel from 'components/inputWithLabel/InputWithLabel';
import { Button } from 'components/buttons/index';
import FormMessage from 'components/formMessage/FormMessage';
import { translate } from 'utils/translateUtil';
import { connect } from 'react-redux';
import {validate} from 'store/self-auth/selfAuthActions';
import Checkbox from 'components/checkbox/checkbox';
import SantanderDatepicker from 'components/DatePicker';
import moment from 'moment';
import validateTIN from 'utils/taxValidatorUtil';
import { ROUTES } from 'constants/routes';

type Props = {
    isPending: boolean;
    config:any;
    history?:any;
    cookies:object;
    error: {
        hasError: boolean,
        message: string
    };
    validate?:any;
    selfAuth: any;
    busy:boolean;
};

class LoginForm extends React.Component<Props, any> {
    constructor(props:Props) {
        super(props);
        this.state = {
            validation: {
                name: false,
                surname: false,
                tin: false,
                birthdate: false,
                postcode: false
            },
            formValues: {
                name: '',
                surname: '',
                tin: '',
                birthdate: '',
                postcode: '',
                consentEmailCommunication: true,
            },
            formIsValid: false
        }
    }

    public componentDidUpdate() {
        if(this.props.selfAuth.error){
            this.props.history.push(ROUTES.ERROR);
        }

    }

    public clearPwField = () => {
        this.setState({formValues: {
            ...this.state.formValues,
            value: ''
        }, formIsValid: false})
    }

    public onSubmit = (ev:any) => {
        ev.preventDefault();
        const {birthdate} = this.state.formValues;
        const formated = moment(birthdate).format('YYYY-MM-DD');
        const params = {
            ...this.props.cookies,
            ...this.state.formValues,
            birthdate: formated
        }
        this.props.validate(params, this.props.config)
    }

    public isDisabled = () => {
        const {formIsValid} = this.state;
        const { busy } = this.props.selfAuth;
        const value =  formIsValid ? busy ? true : false : true;     
        return value
    }
    public onInputChange = (event:any) => {
        if (event.type === 'change') {
            let inputValue = event.target.value;
            let inputValid = inputValue.length > 0 ? true : false;
            if(event.target.id === 'tin'){
                inputValid = validateTIN(event.target.value)
                inputValue = inputValid ?  event.target.value : this.state.formValues.tin;
            }
            if(event.target.id === 'postcode'){
                inputValid = inputValue.length === event.target.maxLength
            }
            if(event.target.id === 'name' || event.target.id === 'surname'){
                const specialChars = new RegExp(/^[a-zA-Z\xC4\xCB\xCF\xD6\xDC]{1}[a-zA-Z\xC4\xCB\xCF\xD6\xDC\xDF\xE4\xEB\xF6\xFC\-\s]*$/g);
                inputValid= specialChars.test(event.target.value);
                inputValue = inputValid ? event.target.value : this.state.formValues[event.target.id] ;
            }
            const validationObj = {
                ...this.state.validation,
                [event.target.id]: inputValid
            };
            // console.log(validationObj);
            this.setState({
                validation: validationObj,
                formIsValid: this.getValidFields(validationObj),
                formValues: {
                    ...this.state.formValues,
                    [event.target.id]: inputValue.trim()
                }
            });
        }
    };

    // TODO: refactor and move this out to helpers
    public  getValidFields = (validationObj:object):boolean => {
        const validationArr = Object.keys(validationObj);
        const validFields = validationArr.reduce((acc, curr) => {
            acc += (validationObj as Record<string, unknown>)[curr] === true ? 1 : 0;
            return acc;
        }, 0);
        return validFields === validationArr.length;
    };
    public toggleCheckbox = () => {
        const {consentEmailCommunication} = this.state.formValues;
        this.setState({
            formValues: {
                ...this.state.formValues,
                consentEmailCommunication: !consentEmailCommunication
            }
        })
    }
    public onDateChange = (value:any) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                ...value
            },
            validation:{
                ...this.state.validation,
                birthdate: true
            }
        })
    }
    public render() {
        const {
            validation,
            formValues,
            } = this.state;
        const {
            error,
            busy
            } = this.props;
        // const {busy} = this.props.selfAuth;
        const {
            name,
            surname,
            tin,
            postcode,
            birthdate,
            consentEmailCommunication,
            } = formValues;

        return (
            <form onSubmit={this.onSubmit}>
                {error.hasError && (
                    <FormMessage>{error.message}</FormMessage>
                )}

                <div>
                    <InputWithLabel
                        id={'name'}
                        value={name}
                        label={translate('main-page.name')}
                        valid={validation.name}
                        maxLength={70}
                        liftEventInfo={this.onInputChange}
                        className={styles.marginBottomInput}
                        hasValidation={true}
                    />
                </div>
                <div>
                    <InputWithLabel
                        id={'surname'}
                        value={surname}
                        maxLength={70}
                        label={translate('main-page.surname')}
                        valid={validation.surname}
                        liftEventInfo={this.onInputChange}
                        className={styles.marginBottomInput}
                        hasValidation={true}
                    />
                </div>
                <div>
                    <InputWithLabel
                        id={'tin'}
                        value={tin}
                        label={translate('main-page.tin')}
                        valid={validation.tin}
                        liftEventInfo={this.onInputChange}
                        className={styles.marginBottomInput}
                        onlyNumbers={true}
                        hasValidation={true}
                        maxLength={14}
                        pattern={true}
                    />
                </div>
                <div>
                    <SantanderDatepicker 
                        label={translate('main-page.birthdate')} 
                        name={'birthdate'} 
                        onDateChange={this.onDateChange}
                        className={styles.marginBottomInput}
                        date={birthdate}
                        />
                </div>
                <div>
                    <InputWithLabel
                        id={'postcode'}
                        value={postcode}
                        maxLength={5}
                        label={translate('main-page.postcode')}
                        valid={validation.postcode}
                        liftEventInfo={this.onInputChange}
                        className={styles.marginBottomInput}
                        onlyNumbers={true}
                        hasValidation={true}
                    />
                </div>
                <div>
                    <Checkbox checkBoxIsClicked={consentEmailCommunication} toggleCheckBoxIsClicked={this.toggleCheckbox}/>
                </div>
                <Button type={'submit'}
                    busy={busy}
                    disabled={this.isDisabled()}
                    className={styles.button}
                    buttonFullWidth={true}
                >
                    {translate('main-page.btn-submit')}
                </Button>
            </form>
        );
    }
}

const mapDispatchToProps = {
    validate
};

const mapStatesToProps = (state:any) => {
    return {
        selfAuth: state.selfAuth,
        busy: state.selfAuth.busy
    }
}

export default connect(
    mapStatesToProps,
    mapDispatchToProps
)(LoginForm as any) as any;
